export default __webpack_public_path__ + "static/media/caret-up.4ad71baf.svg";